/**
 * DialogProvider: LUXDialog 싱글턴 렌더러를 자식과 함께 마운트
 *
 * React 19 호환 — Functional Component.
 * <RenewalDialogProvider> 로 감싸면 LUXDialog.alert / confirm 사용 가능.
 */
import React from 'react';
import { DialogRenderer } from '../LUXDialog';

interface DialogProviderProps {
  children: React.ReactNode;
  style?: React.CSSProperties;
  className?: string;
}

const DialogProvider: React.FC<DialogProviderProps> = ({ children, style, className }) => {
  return (
    <div style={style} className={className}>
      {children}
      <DialogRenderer />
    </div>
  );
};

export default DialogProvider;
